import PropTypes from 'prop-types';
import React from 'react';
import DrawerContext from '../context';
import Drawer from './Drawer';

const DrawerWithContext = ({ name, children, rightSide }) => (
  <DrawerContext.Consumer>
    {({ registerToggle }) => (
      <Drawer registerToggle={registerToggle} name={name} rightSide={rightSide}>
        {children}
      </Drawer>
    )}
  </DrawerContext.Consumer>
);

DrawerWithContext.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string.isRequired,
  rightSide: PropTypes.bool
};

export default DrawerWithContext;
